import React from 'react'

export const available = ({ details }) => !(details && details.SPPersonnelId)

// eslint-disable-next-line react/display-name
const migrateForm = ({ gov_person_registrations = [{}] }) => () => (
  <fieldset>
    Some explanitory text about how {gov_person_registrations[0].first_name || 'this person'} will
    be changed once they start using Xplor
  </fieldset>
)

const apiEndPoint = ({ gov_id }) =>
  process.env.REACT_APP_API_HOST + `/api/gov-person-registrations/${gov_id}/update-sp-id`

const migateToXplor = ({ record }) =>
  available(record)
    ? {
      label: 'Migrate to Xplor',
      value: 'migrate_xplor',
      component: migrateForm(record),
      url: apiEndPoint(record),
    }
    : null

export default migateToXplor



// WEBPACK FOOTER //
// ./src/personnel/details/gov-personnel/migrate-to-xplor.js